export default class History {
  constructor (events=[]) {
    this.events = events
  }

  push (event) {
    this.events.push(event)
  }

  last (filter = () => true) {
    for (let i = this.events.length - 1; i >= 0; i--) {
      let event = this.events[i]
      if (filter(event)) {
        return event
      }
    }
    return undefined
  }

  mount (character) {
    character.on('get:over', ({ raw, value }) => this.push(new History.CalculationEvent(raw, value)))
    character.on('execution:over', ({ raw, value }) => this.push(new History.ExecutionEvent(raw instanceof String ? raw : Object.keys(raw)[0]), value))
  }

  clear () {
    this.events = []
  }

  // serialization
  toJson () {
    return History.serialize(this)
  }

  static deserialize (jsonEvents) {
    return new History(jsonEvents.map(event => {
      if (event.type === 'calc') {
        return History.CalculationEvent.desirialize(event)
      } else if (event.type === 'exec') {
        return History.ExecutionEvent.desirialize(event)
      }
    }))
  }

  static serialize (history) {
    return history.events.map(event => event.toJson())
  }
}

History.Event = class HistoryEvent {
  constructor (name, date=Date.now(), type='event') {
    Object.assign(this,  { name, date })
  }

  _log () {
    return `[${this.date}] ${this.name}`
  }

  _toJson () {
    return { name: this.name, date: this.date }
  }
}

History.CalculationEvent = class CalculationHistoryEvent extends History.Event {
  constructor (name, value, date) {
    super(name, date, 'calc')
    this.value = value
  }

  log () {
    return `${this._log()} (calculation): value=${value}`
  }

  toJson () {
    return History.CalculationEvent.serialize(this)
  }

  static desirialize (json) {
    return new History.CalculationEvent(json.name, json.value, json.date)
  }

  static serialize (event) {
    return Object.assign({ type: 'calc', value: event.value }, event._toJson())
  }
}

History.ExecutionEvent = class ExecutionHistoryEvent extends History.Event {
  constructor (name, value, date) {
    super(name, date, 'exec')
    this.value = value
  }

  log () {
    return `${this._log()} (execution): value=${value}`
  }

  toJson () {
    return History.ExecutionEvent.serialize(this)
  }

  static desirialize (json) {
    return new History.ExecutionEvent(json.name, json.value, json.date)
  }

  static serialize (event) {
    return Object.assign({ type: 'exec', value: event.value }, event._toJson())
  }
}
